<template>
  <div>
    <div class="extension-page">
      <svg class="icon" aria-hidden="true" v-if="$route.query.isApp != 1">
        <use xlink:href="#icon-daiwenzilogo"></use>
      </svg>
      <div class="extension-page-container">
        <h1 class="bold">Listing Extension Application</h1>
        <div class="extension-rules">
          <p>We regret to inform you that the trading pair you have listed does not meet the relevant performance
            requirements and will soon be delisted, meaning it will no longer be available to the public. </p>
          <p>Performance Requirement 1: Weekly trading volume is larger than
            <em class="normal underline">{{ resultVal ? fixNumber(resultVal.downType1, 0) : '--' }}</em> USDT. </p>
          <p>Performance Requirement 2: Weekly transaction amount is larger than
            <em class="normal underline">{{ resultVal ? resultVal.downType2 : '--' }}</em>. </p>
          <p>If you wish to maintain the listing status of your trading pair, we kindly request that you promptly apply
            for the Extension and pay an Administration Fee of <em
                class="normal underline">{{ resultVal ? `${resultVal.amount} ${resultVal.unit}` : '--' }}</em>. Upon
            payment, your trading pair will remain
            active for an additional <em class="normal underline">{{ resultVal ? resultVal.day : '--' }}</em> days.
            After <em class="normal underline">{{ resultVal ? resultVal.day : '--' }}</em> days, if the trading metrics
            of your pair satisfy the Performance Requirements, it shall continue to remain listed. </p>
          <p>We strongly advise you to apply for the Extension to avoid being officially terminated by
            <em class="normal underline">{{ resultVal ? formatDate(resultVal.shortTime) : '' }}</em>. Thank you for your understanding and
            cooperation. </p>
        </div>
        <div class="extension-buttons">
          <button class="form-btn" :disabled="!resultVal || resultVal.isPay == 1" @click="handleExtension">APPLY and
            PAY
          </button>
          <p v-if="resultVal && resultVal.isPay == 0">You will be charged
            {{ resultVal ? `${resultVal.amount} ${resultVal.unit}` : '--' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {memoInfoApi, payUpFee} from "../api/spot";
import {mapGetters} from "vuex";
import Methods from '../utils/methods'
import {Toast} from "vant";
import {setToken} from "../utils/auth";

export default {
  name: "extensionPage",
  data() {
    return {
      resultVal: null,
      upFee: '',
      disabledButton: false
    }
  },
  computed: {
    ...mapGetters(['isDirection', 'token'])
  },
  created() {
    let token = this.$route.query.token || this.token
    if (token) {
      setToken(token)
      this.$store.dispatch('GetInfo', token)
      this.$store.dispatch('setToken', token)
      this.getMemoInfo()
      return false
    } else {
      this.$route.query.isApp == 1 ? this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogin, {
        code: 200,
        type: 'login'
      }, (data) => {
      }) : this.$router.push("/login?historyBack=" + window.encodeURIComponent(this.$route.fullPath));
    }
  },
  methods: {
    fixNumber(val, unit) {
      if (val && String(val).indexOf('.') > -1) {
        return Methods.fixNumber(val, unit)
      } else {
        return val
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return ''
      // 创建一个日期对象
      let date = new Date(timestamp)
      // 定义月份的英文名称
      let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      // 获取日期的各个部分
      let year = date.getFullYear()
      let month = months[date.getMonth()]
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds()
      // 构造最终的日期格式
      let formattedDate = `${month} ${day}`
      return formattedDate
    },
    getMemoInfo() {
      memoInfoApi({memoId: this.$route.query.memoId}).then(res => {
        this.resultVal = res.data
      })
    },
    handleExtension() {
      payUpFee({memoId: this.$route.query.memoId}).then(res => {
        this.getMemoInfo()
        Toast(res.msg)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/mixin";
@import "../assets/css/variableName";

.extension-page {
  height: 100vh;
  background-color: #FFFFFF;

  svg {
    width: torem(102);
    height: torem(22);
    margin: torem(12) torem(24);
  }

  &-container {
    width: 100%;
    margin: 0 auto;
    padding: torem(16);

    h1 {
      font-size: torem(16);
      line-height: 1.2;
      margin-bottom: torem(20);
    }

    .extension-rules {
      p {
        font-size: torem(12);
        line-height: 1.5;
        color: #40475A;
        margin-bottom: torem(14);
      }
    }

    .extension-buttons {
      text-align: center;
      margin-top: torem(120);

      .form-btn {
        background-color: #FFC72B;
        width: torem(319);
        height: torem(44);
        line-height: torem(44);
        margin-bottom: torem(12);

        &:disabled {
          background-color: rgba(0, 0, 0, 0.1);
          color: #7F8490;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/extensionPage.vue